import TenTableBodyCell from './table-body-cell.js';
import TenTableHeadCell from './table-head-cell.js';
import domHelper from '../scripts/utils/dom-helper';
import { removeUndefinedAttr } from '../scripts/utils/helper';

function getHeight(_height) {
  let height = _height;
  if (typeof height === 'number') return height;
  if (typeof height === 'string') height = Number(height.replace(/px$/, ''));
  if (!isNaN(height)) return height;
}

export default {
  name: 'ten-table-table',
  inject: ['table'],
  props: {
    /**
     * 表头树
     */
    columnsTree: {
      type: Array,
      default: () => [],
    },
    /**
     * 表头的叶子节点列表
     */
    columns: {
      type: Array,
      default: () => [],
    },
    rowProps: Function,
    /**
     * 表头树的深度
     */
    depth: {
      type: Number,
      default: 0,
    },
    /**
     * 表格数据
     */
    data: {
      type: Array,
      default: () => [],
    },
    sizeData: {
      type: Object,
      default: () => ({
        width: undefined,
        trHeights: [],
        thWidths: [],
      }),
    },
    /**
     * 无数据提示
     */
    emptyText: [String, Function],
    /**
     * 固定的方向
     */
    fixed: String,
    /**
     * 固定的列
     */
    fixedColumns: Array,
    /**
     * 同步的scrollTop
     */
    scrollTop: Number,
    /**
     * 实际渲染的table的宽度，
     * 当用户没有为所有col设定宽度时，
     * fixed-table的inner-table的宽度
     * 需要使用middle-table的inner-table的宽度
     */
    innderTableWidth: Number,
    hoverRowIndex: Number,
  },
  data() {
    return {
      theadHeight: 0,
      fixedTableWidth: undefined, // fixed-table-wrapper的宽度
      tbodyScrollTop: 0,
      tbodyHeight: 0,
      scrollbarWidth: 15,
      scrollStatus: 'left',
    };
  },
  computed: {
    tbodyWrapperMaxHeight() {
      const height = getHeight(this.table.maxHeight);
      return height && height - this.theadHeight;
    },
    tbodyWrapperHeight() {
      const height = getHeight(this.table.height);
      return height && height - this.theadHeight;
    },
    tableClassName() {
      return [
        'ten-table__table',
        {
          'ten-table__table--fixed': this.fixed,
          [`ten-table__table--fixed-${this.fixed}`]: this.fixed,
          [`is-scrolling--${this.scrollStatus}`]: this.scrollStatus,
        },
      ];
    },
    expandCol() {
      return this.columns.find(col => col.type === 'expand');
    },
    hasExpand() {
      return !!this.expandCol;
    },
    scrollableY() {
      const tbodyWrapperHeight =        this.tbodyWrapperMaxHeight
        || this.tbodyWrapperHeight
        || this.tbodyHeight;
      return tbodyWrapperHeight - this.tbodyHeight < 0;
    },
    fixedPrefix() {
      const fixedPrefix = this.fixed ? this.fixed : 'base';
      return fixedPrefix;
    },
  },
  watch: {
    scrollTop(v) {
      if (this.$refs.tbodyWrapper) {
        this.$nextTick(() => {
          this.$refs.tbodyWrapper.scrollTop = v;
        });
      }
    },
    $route: {
      handler() {
        this.doLayout();
      },
    },
  },
  mounted() {
    this.doLayout();
    this.initEventHandler();
    this.$on('do-layout', this.doLayout);
    this.passiveScroll = false;
    this.scrollbarWidth = domHelper.getBrowserScrollSize();
  },
  updated() {
    this.setWrapperStyle();
  },
  beforeDestroy() {
    this.removeEventHandler();
  },
  render(h) {
    const allRow = [];
    this.getHeadRow(h, this.columnsTree, allRow);
    let tableWidth;
    if (this.fixed || this.table.scrollableX) {
      if (this.scrollableY) {
        tableWidth = this.innderTableWidth - this.scrollbarWidth;
      } else {
        tableWidth = this.innderTableWidth;
      }
      tableWidth += 'px';
    }

    let theadStyle = { width: tableWidth };
    let theadWrapperStyle = {};
    let tbodyStyle = {
      width: tableWidth,
    };
    let tbodyWrapperStyle = {
      top: this.fixed ? `${this.theadHeight}px` : undefined,
      maxHeight: `${this.tbodyWrapperMaxHeight}px`,
      height: `${this.tbodyWrapperHeight}px`,
    };

    if (this.scrollableY && this.fixed !== 'left') {
      theadWrapperStyle['margin-right'] = `${this.scrollbarWidth}px`;
    }

    theadStyle = domHelper.filterCssStyles(theadStyle);
    theadWrapperStyle = domHelper.filterCssStyles(theadWrapperStyle);
    tbodyWrapperStyle = domHelper.filterCssStyles(tbodyWrapperStyle);
    tbodyStyle = domHelper.filterCssStyles(tbodyStyle);

    const colgroup = this.renderColgroup();

    return (
      <div ref='tableWrapper' class={this.tableClassName}>
        {this.table.hideHeader ? null : (
          <div
            ref='theadWrapper'
            class='ten-table__table-head'
            style={theadWrapperStyle}
          >
            <table
              cellspacing='0'
              cellpadding='0'
              border='0'
              style={theadStyle}
            >
              { colgroup }
              <thead>{allRow}</thead>
            </table>
          </div>
        )}
        <div
          ref='tbodyWrapper'
          class='ten-table__table-body'
          style={tbodyWrapperStyle}
          onMouseleave={this.onTbodyMouseLeave}
        >
          <table
            ref='tbody'
            cellspacing='0'
            cellpadding='0'
            border='0'
            style={tbodyStyle}
          >
            { colgroup }
            <tbody ref='tbody'>
              {this.data.length > 0 ? (
                this.data.map((row, i) => this.renderRows(h, row, i))
              ) : (
                <tr>
                  <td
                    class='ten-table__table-cell ten-table__table-cell--empty-text'
                    colspan={this.columns.length}
                  >
                    {typeof this.emptyText === 'function'
                      ? this.emptyText()
                      : this.emptyText}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  },
  methods: {
    onResize() {
      setTimeout(() => {
        if (this.$refs.theadWrapper) {
          this.theadHeight = this.$refs.theadWrapper.offsetHeight;
        }
      });
      if (!this.fixed && this.$el) {
        this.$emit('resize', this.$el);
      }

      setTimeout(() => {
        if (this.$refs.tbody) {
          this.tbodyHeight = this.$refs.tbody.offsetHeight;
        }
      });
      setTimeout(() => {
        this.setWrapperStyle();
      });
    },
    onScroll() {
      if (this.passiveScroll) {
        this.passiveScroll = false;
        return;
      }
      if (this.$refs.tbodyWrapper && this.$refs.theadWrapper) {
        this.$refs.theadWrapper.scrollLeft = this.$refs.tbodyWrapper.scrollLeft;
        let scrollStatus;
        if (!this.fixed) {
          if (this.$refs.tbodyWrapper.scrollLeft === 0) {
            scrollStatus = 'left';
          } else if (
            this.$refs.tbodyWrapper.scrollWidth
              - this.$refs.tbodyWrapper.clientWidth
            <= this.$refs.tbodyWrapper.scrollLeft
          ) {
            scrollStatus = 'right';
          } else {
            scrollStatus = 'middle';
          }
        }

        this.$emit('scroll', {
          tbodyScrollTop: this.$refs.tbodyWrapper.scrollTop,
          scrollStatus,
          target: this,
        });
      }
    },
    setScrollTop(scrollTop) {
      if (this.$refs.tbodyWrapper) {
        this.passiveScroll = true;
        this.$refs.tbodyWrapper.scrollTop = scrollTop;
      }
    },
    setBodyHover(index) {
      if (this.$refs.tbody) {
        const trs = this.$refs.tbody.querySelectorAll('tr');
        [...trs].forEach((tr) => {
          const trIndex = tr.getAttribute('data-row-index');
          if (trIndex && Number(trIndex) === index) {
            tr.classList.add('ten-table__table-row--hover');
          } else {
            tr.classList.remove('ten-table__table-row--hover');
          }
        });
      }
    },
    setWrapperStyle() {
      const fixedTableWidth = this.getTableWrapperWidth();
      if (!fixedTableWidth) {
        return;
      }
      const tableWrapperStyle = { width: `${fixedTableWidth}px` };
      const theadWrapperStyle = {};
      const tbodyWrapperStyle = {
        top: `${this.theadHeight}px`,
        'max-height': `${this.tbodyWrapperMaxHeight}px`,
        height: `${this.tbodyWrapperHeight}px`,
      };
      if (this.scrollableY) {
        if (this.fixed === 'left') {
          tbodyWrapperStyle['margin-right'] = `${-this.scrollbarWidth}px`;
          tbodyWrapperStyle['padding-right'] = `${this.scrollbarWidth}px`;
        } else {
          // theadWrapperStyle['padding-right'] = `${this.scrollbarWidth}px`;
          tableWrapperStyle.width = `${fixedTableWidth + this.scrollbarWidth}px`;
          tbodyWrapperStyle.width = `${this.innderTableWidth}px`;
        }
      } else {
        tbodyWrapperStyle['margin-right'] = '';
        tbodyWrapperStyle['padding-right'] = '';
        theadWrapperStyle['padding-right'] = '';
      }

      if (this.table.scrollableX) {
        tbodyWrapperStyle['margin-bottom'] = `${-this.scrollbarWidth}px`;
        tbodyWrapperStyle['padding-bottom'] = `${this.scrollbarWidth}px`;
        tableWrapperStyle['margin-bottom'] = this.scrollbarWidth
          ? `${this.scrollbarWidth + 1}px`
          : 0;
      } else {
        tbodyWrapperStyle['margin-bottom'] = '';
        tbodyWrapperStyle['padding-bottom'] = '';
        tableWrapperStyle['margin-bottom'] = '';
      }
      domHelper.setStyles(this.$refs.tableWrapper, tableWrapperStyle);
      domHelper.setStyles(this.$refs.theadWrapper, theadWrapperStyle);
      domHelper.setStyles(this.$refs.tbodyWrapper, tbodyWrapperStyle);
    },
    initEventHandler() {
      this.$refs.tbodyWrapper
        && this.$refs.tbodyWrapper.addEventListener('scroll', this.onScroll);
      window.addEventListener('resize', this.onResize);
    },
    removeEventHandler() {
      this.$refs.tbodyWrapper
        && this.$refs.tbodyWrapper.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    },
    getTableWrapperWidth() {
      if (this.$refs.theadWrapper) {
        const cols = Array.from(this.$refs.theadWrapper.querySelectorAll(`th[is-leaf][fixed="${this.fixed}"]`));
        return cols.reduce((acc, cur) => acc + cur.offsetWidth, 0);
      }
      return 0;
    },
    renderColgroup() {
      const { columns, innderTableWidth } = this;
      const definedWidthColumns = columns.filter(column => column.validWidth);
      const totalDefinedWidth = definedWidthColumns.reduce((p, c) => {
        if (c.validWidth < 1) {
          // percent
          return p + (c.validWidth * innderTableWidth);
        }
        return p + c.validWidth;
      }, 0);
      let remainWidth = innderTableWidth - totalDefinedWidth;
      const averageWidth = remainWidth / (columns.length - definedWidthColumns.length);
      return (
        <colgroup>
          {
            columns.map((column, i) => {
              let width;
              if (innderTableWidth && !column.validWidth && column.validMinWidth) {
                // 如果当前列 minWidth 大于可剩余可分配宽度，则 minWidth 生效
                let { validMinWidth } = column;
                if (validMinWidth < 1) {
                  validMinWidth = validMinWidth * innderTableWidth;
                }
                if (validMinWidth > averageWidth && validMinWidth < remainWidth) {
                  remainWidth -= validMinWidth;
                  width = column.minWidth;
                }
              } else if (column.validWidth) {
                width = column.width; // eslint-disable-line
              }
              const colProps = {
                attrs: removeUndefinedAttr({
                  width,
                }),
              };
              return <col key={i} { ...colProps } />;
            })
          }
        </colgroup>
      );
    },
    getHeadRow(h, row, allRow) {
      if (row && row.length > 0) {
        let newRow = [];
        allRow.push(<tr>
            {row.map((cell, i) => {
              const pureId = `th-${allRow.length}-${i}`;
              const id = `${this.fixedPrefix}-${pureId}`;
              let invisible = false;
              if (
                (!this.fixed && this.table.scrollableX && cell.fixed)
                || (this.fixed
                  && this.table.scrollableX
                  && cell.fixed !== this.fixed)
              ) {
                invisible = true;
              }
              if (cell.children) {
                newRow = newRow.concat(cell.children);
              }
              return (
                <TenTableHeadCell
                  id={id}
                  pureId={pureId}
                  data-cell-id={id}
                  rowspan={this.depth - cell.depth + 1}
                  colspan={cell.leafCount}
                  column={cell}
                  data-th-invisible={invisible ? 1 : 0}
                  is-leaf={cell.isLeaf}
                  fixed={cell.fixed}
                  invisible={invisible}
                />
              );
            })}
          </tr>);
        this.getHeadRow(h, newRow, allRow);
      }
    },
    renderRows(h, row, i) {
      return this.renderRow(h, row, i);
    },
    renderRow(h, row, i) {
      const expanded = this.showExpandRow(row);
      let rowProps = this.rowProps(row, i);
      rowProps = rowProps || {};

      // 是否绑定拖拽功能
      const dragProps = this.table.dragSort ? {
        attrs: {
          draggable: this.table.dragSort,
        },
        on: {
          dragstart: this.handleDragstart,
        },
      } : {};
      const content = [
        <tr
          class={{
            'ten-table__table-row--expanded': expanded,
            'ten-table__table-row--hover': this.hoverRowIndex === i,
            'ten-table__table-row--selected':
              Array.isArray(this.table.selectedRowKeys)
              && this.table.selectedRowKeys.indexOf(this.table.getRowKey(row)) > -1,
          }}
          data-row-index={i}
          key={row[this.table.getRowKey(row)] || i}
          onMouseenter={() => {
            this.onRowMouseEnter(i);
          }}
          {...rowProps}
          {...dragProps}
        >
          {this.columns.map((column, j) => {
            const pureId = `td-${i}-${j}`;
            const id = `${this.fixedPrefix}-${pureId}`;
            let invisible = false;
            if (
              (!this.fixed && this.table.scrollableX && column.fixed)
              || (this.fixed
                && this.table.scrollableX
                && column.fixed !== this.fixed)
            ) {
              invisible = true;
            }
            return (
              <TenTableBodyCell
                key={j}
                id={id}
                pureId={pureId}
                data-cell-id={id}
                column={column}
                row={row}
                rowIndex={i}
                colIndex={j}
                expanded={expanded}
                invisible={invisible}
                data-invisible={invisible}
              />
            );
          })}
        </tr>,
      ];

      if (this.hasExpand) {
        const { renderCell, render } = this.expandCol;
        let expandContent;

        if (renderCell && typeof renderCell === 'function') {
          expandContent = renderCell({
            row,
            column: this.expandCol,
            $index: i,
          });
        } else {
          expandContent = typeof render === 'function'
            ? render(h, { row, column: this.expandCol, $index: i })
            : row[render];
        }
        content.push(<tr
            class='ten-table__table-row--expand'
            key={`${row[this.table.getRowKey(row)] || i}_expand`}
            v-show={expanded}
          >
            <td colspan={this.columns.length}>
              <div class='ten-table__table-cell'>{expandContent}</div>
            </td>
          </tr>);
      }

      return content;
    },
    handleDragstart(e) {
      function findNode(node, bool) {
        if (!node) return node;
        if (bool && bool(node)) return node;
        return findNode(node.parentNode, bool);
      }

      function findNodeToTR(node) {
        return findNode(node, node => node.nodeName === 'TR');
      }

      function findNodeIndex(node) {
        return [].indexOf.call(parent.children, node);
      }

      const parent = findNode(e.target, node => node.nodeName === 'TBODY');
      const dragNode = findNodeToTR(e.target);
      const dragNodeIndex = findNodeIndex(dragNode);

      dragNode.style.opacity = 0.6;

      // 拖拽移动的过程中，对移入的目标
      function dragenter(event) {
        const enterDrag = findNode(event.target, node => node.nodeName === 'TR');
        const enterDragIndex = findNodeIndex(enterDrag);
        if (dragNode === enterDrag) return true;
        // 用于判断是否为上插入还是下插入的提示
        // enterDrag.style.boxSizing = 'border-box';
        if (dragNodeIndex > enterDragIndex) {
          enterDrag.style.borderTop = '2px #0052d9 dashed';
        } else {
          enterDrag.style.borderBottom = '2px #0052d9 dashed';
        }
      }
      parent.addEventListener('dragenter', dragenter);

      // 拖拽离开目标时，恢复样式
      function dragleave(event) {
        const leaveDrag = findNodeToTR(event.target);
        if (dragNode === leaveDrag) return true;
        leaveDrag.style.borderBottom = '';
        leaveDrag.style.borderTop = '';
      }
      parent.addEventListener('dragleave', dragleave);

      // 拖拽动作结束的时候，拖拽节点样式恢复
      // 清除所有事件
      function dragend() {
        dragNode.style.opacity = '';
        clearEvent();
      }
      parent.addEventListener('dragend', dragend);

      function dragover() {
        // 阻止默认动作
        event.preventDefault();
      }
      parent.addEventListener('dragover', dragover);

      const drop = (event) => {
        // 阻止默认动作（如打开一些元素的链接）
        event.preventDefault();
        const targetNode = findNodeToTR(event.target);
        const targetNodeIndex = findNodeIndex(targetNode);

        if (dragNodeIndex > targetNodeIndex) {
          // 上插入
          parent.insertBefore(dragNode, targetNode);
        } else {
          // 下插入
          const targetNextNode = targetNode.nextSibling;
          parent.insertBefore(dragNode, targetNextNode);
        }

        // 初始化 style 样式
        targetNode.style.borderBottom = '';
        targetNode.style.borderTop = '';
        dragNode.style.opacity = '';

        // 返回拖拽排序完成后的数组
        const trDoms = parent.querySelectorAll('tr');
        const newData = [].map.call(trDoms, (item) => {
          const rowIndex = item.getAttribute('data-row-index');
          return this.data[+rowIndex];
        });
        // 触发父级 sort 事件
        this.table.$emit('sort', newData, 'drag');
        clearEvent();
      };

      // 用于清除拖拽的事件
      function clearEvent() {
        parent.removeEventListener('drop', drop);
        parent.removeEventListener('dragenter', dragenter);
        parent.removeEventListener('dragleave', dragleave);
        parent.removeEventListener('dragend', dragend);
        parent.removeEventListener('dragover', dragover);
      }

      parent.addEventListener('drop', drop);
    },
    doLayout() {
      this.$nextTick(() => {
        this.onResize();
        this.onScroll();
      });
    },
    onRowMouseEnter(i) {
      this.$emit('hoverChange', i);
    },
    onTbodyMouseLeave() {
      this.$emit('hoverChange', -1);
    },
    showExpandRow(row) {
      if (!this.hasExpand) return;
      const rowKey = this.table.getRowKey(row);
      return !!this.table.expandedRowKeys.find(key => key === rowKey);
    },
  },
};
